import type { CreditAccountTopUp } from "./CreditAccountTopUp.container";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { TopUpCreditCardList } from "./TopUpCreditCardList";

export const CreditAccountTopUpScreen = ({
  openModal,
  handleClose,
  creditPackages,
  handleSelectPackage,
  packageDetailsLoading,
  topUpLoading,
}: CreditAccountTopUp) => {
  return (
    <BottomDrawerModal open={openModal} onOpenChange={handleClose}>
      <TopUpCreditCardList
        creditPackages={creditPackages}
        handleClick={handleSelectPackage}
        packageDetailsLoading={packageDetailsLoading}
        topUpLoading={topUpLoading}
      />
    </BottomDrawerModal>
  );
};
